import * as T from 'three';

// Entity alpha and tint multiply the VMT; changing entity state must not erase
// a material's translucency, alpha test or additive blend mode.
export function applyRenderState(material, { renderMode = 0, color = [255, 255, 255], alpha = 255, cloaked = false } = {}) {
    const base = material.userData.sourceRenderState ??= {
        color: material.color.toArray(), opacity: material.opacity,
        transparent: material.transparent, depthWrite: material.depthWrite, blending: material.blending,
    };
    const tint = new T.Color().setRGB(...color.map(v => v / 255), T.SRGBColorSpace);
    material.color.fromArray(base.color).multiply(tint);
    material.opacity = base.opacity * (renderMode === 10 ? 0 : renderMode ? alpha / 255 : 1) * (cloaked ? .15 : 1);
    material.transparent = base.transparent || material.opacity < 1 || [3, 5, 9].includes(renderMode);
    material.depthWrite = base.depthWrite && !material.transparent;
    material.blending = [3, 5, 9].includes(renderMode) ? T.AdditiveBlending : base.blending;
    material.needsUpdate = true;
}
